import React from 'react';
import CardCommon from '@op/components/CardCommon';
import RenderGameIcon from '@op/components/RenderImg/renderGameIcon';
import KPICell from '@opm/components/KPICell';
import useIntls from '@opm/hooks/useIntls';
import type { TGameMap } from '@opm/pages/CompetitorAdComparison/hooks/useGameMap';
import {
  TTopicTypeColorMap,
} from '@opm/pages/CreativeTrends/utils';
import TrendTopicTags from '@opm/pages/CreativeTrends/components/TrendTopicTags';
import { ITrendDetail } from '../../../types';
import '@opm/pages/CreativeTrends/Details/component/TrendInfo/index.scss';
import AISummaryBlock from '@opm/pages/CreativeTrends/components/AISummaryBlock';

interface ITrendInfoProps {
  data: ITrendDetail | null;
  loading: boolean;
  filter?: any;
  gameMap?: TGameMap;
  /** Topic Type chip 颜色映射（按 L1 parent 取色，L2 共享 parent 色） */
  topicTypeColorMap?: TTopicTypeColorMap;
}

export default function TrendInfo({
  data,
  loading,
  filter,
  gameMap,
  topicTypeColorMap,
}: ITrendInfoProps) {
  const { intl } = useIntls();
  const gameMeta = data?.game_id ? gameMap?.[data.game_id] : undefined;
  const gameName = gameMeta?.game_name || data?.game_id || '-';
  const gameCover = gameMeta?.cover || '';

  return (
    <CardCommon
      className="dbom-ct-trend-info"
      loading={loading}
      loadingHeight={302}
      emptyHeight={302}
      empty={!data || Object.keys(data).length === 0}
      hasEmptyImg={false}
      contentCard={false}
      title={intl('Related Videos')}
    >
      <div className="dbom-ct-trend-info__kpi-row">
        <div className="dbom-ct-trend-info__col">
          <div className="dbom-ct-trend-info__label">{intl('Game')}</div>
          <div className="dbom-ct-trend-info__game">
            <RenderGameIcon
              className="dbom-ct-trend-info__game-logo"
              gameInfo={{
                cover: gameCover,
                entity_type: (data as any)?.entity_type,
                edition_unified_id: data?.game_id,
              }}
            />
            <span className="dbom-ct-trend-info__game-name" title={gameName}>
              {gameName}
            </span>
          </div>
        </div>
        <KPICell
          label={intl('Views')}
          kpiData={(data as any)?.tweets_view}
          filter={filter}
          size="lg"
        />
        <KPICell
          label={intl('Likes')}
          kpiData={(data as any)?.tweets_like}
          filter={filter}
          size="lg"
        />
        <KPICell
          label={intl('Videos')}
          kpiData={(data as any)?.videos}
          filter={filter}
          size="lg"
        />
        <div className="dbom-ct-trend-info__col dbom-ct-trend-info__col--tags">
          <div className="dbom-ct-trend-info__label">
            {intl('Type & Elements')}
          </div>
          <div className="dbom-ct-trend-info__tags">
            <TrendTopicTags
              record={data as any}
              topicTypeColorMap={topicTypeColorMap}
              chipClassName="dbom-ct-trend-info__chip"
            />
          </div>
        </div>
      </div>
      {/* AI Summary */}
      <AISummaryBlock summaryData={data} hasBorder />
    </CardCommon>
  );
}
